import React from "react";
import { CardTitle, Card } from "reactstrap";
import classnames from "classnames";

import { Presenter, Session } from "../../api";
import Avatar from "../../common/components/Avatar";

export interface PresenterListData {
  session: Session;
  presenters: Presenter[];
}

interface PresentersListProps {
  data: PresenterListData[];
}

const PresentersList: React.FC<PresentersListProps> = (props) => {

  const lastIndex = (props.data?.length ?? 0) - 1;

  return (
    <Card className="presentersList">
      <CardTitle
        tag="h5"
        className="mb-0 py-3 text-primary text-center text-uppercase fs-9 fw-6"
      >
        Presenters
      </CardTitle>
      <div style={{ minHeight: "3rem" }}>
        {!!props.data && !!props.data.length && (
          <div className="border-top scroll scroll-auto custom-scrollbar">
            {props.data &&
              props.data.map((item, i) => (
                <div key={i} className={classnames({
                  "px-3 py-2": true,
                  "border-bottom": i !== lastIndex,
                })}>
                  <div className="mb-2 fw-6 text-uppercase">{item.session.name}</div>
                  {item.presenters.map((presenter, i) => (
                    <div key={i} className={classnames({
                      "d-flex": true,
                      "mt-2": 0 < i,
                    })}>
                      <div>
                        <Avatar
                          size="sm"
                          id={presenter.id.toString()}
                          name={presenter.name}
                          src={presenter.photoUri}
                        />
                      </div>
                      <div className="mx-3">
                        <div className="font-weight-bold">
                          {presenter.name}
                        </div>
                        {!!presenter.company && (
                          <div className="text-uppercase fs-10">
                            {presenter.company}
                          </div>)}
                      </div>
                    </div>))}
                </div>
              ))}
          </div>
        )}
      </div>
    </Card>
  );
};

export default PresentersList;
